import component from "./component.js";
import { connect } from "react-redux";

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

const mapStateToProps = (state, ownProps) => {
  return {
    hasSubscription: state.account.hasSubscription,
    isLoggedIn: state.auth.isLoggedIn,
    subscriptionReady: state.account.ready
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(component);



// WEBPACK FOOTER //
// ./src/views/AppMenuAndFrame/index.js